"use client";

import React from "react";
import Link from "next/link";
import { trackEvent } from "fathom-client";

export default function CTAneutral({ resetMenus = () => {} }) {
  return (
    <Link
      href="/schedule-a-consultation"
      className="cta inline-block px-4 py-2 text-neutral-50 border-solid border-neutral-50 outline-1 outline-neutral-50 text-center rounded-sm focus:outline-none font-bold ease-in-out duration-200 hover:scale-[104%] "
      onClick={() => {
        resetMenus();
        trackEvent("CTA in ATF Click", 0);
      }}
    >
      Schedule a Consultation
    </Link>
  );
}
